export const messages = {
  title: { id: 'admin/promotions.form.conditions.payment-methods.title' },
  subtitle: {
    id: 'admin/promotions.form.conditions.payment-methods.subtitle',
  },
  edit: { id: 'admin/promotions.utils.edit' },
  create: { id: 'admin/promotions.utils.create' },
  cancel: { id: 'admin/promotions.utils.cancel' },
  discard: { id: 'admin/promotions.utils.discard' },
  save: { id: 'admin/promotions.utils.save' },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.payment-methods.view.title',
    },
  },
  unauthorized: {
    description: {
      id: 'admin/promotions.form.conditions.payment-methods.unauthorized.description',
    },
  },
}
